<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-add-video-camera`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.718 31c.446 0 .607.046.77.134a.906.906 0 01.378.378c.088.162.134.324.134.77V36h3.718c.446 0 .607.046.77.134a.906.906 0 01.378.378c.088.163.134.324.134.77v1.436c0 .446-.046.607-.134.77a.908.908 0 01-.378.378c-.162.088-.324.134-.77.134H11v3.718c0 .446-.046.607-.134.77a.908.908 0 01-.378.378c-.162.088-.324.134-.77.134H8.282c-.446 0-.607-.046-.77-.134a.908.908 0 01-.378-.378c-.088-.163-.134-.324-.134-.77L6.999 40H3.282c-.446 0-.607-.046-.77-.134a.908.908 0 01-.378-.378c-.088-.163-.134-.324-.134-.77v-1.436c0-.446.046-.607.134-.77a.908.908 0 01.378-.378c.163-.088.324-.134.77-.134L7 35.999v-3.717c0-.446.046-.607.134-.77a.908.908 0 01.378-.378c.163-.088.324-.134.77-.134h1.436zM31 8a2 2 0 011.995 1.85L33 10v28a2 2 0 01-1.85 1.995L31 40H20v-4h9V12H5v15H1V10a2 2 0 011.85-1.995L3 8h28zm16 7.532v16.936c0 1.554-1.865 2.514-3.332 1.715L36 30V18l7.668-4.183c1.467-.8 3.332.16 3.332 1.715zm-4 3.533l-3 1.2v7.47l3 1.2v-9.87zM10 16h4a1 1 0 01.993.883L15 17v4a1 1 0 01-.883.993L14 22h-4a1 1 0 01-.993-.883L9 21v-4a1 1 0 01.883-.993L10 16h4-4z"/></svg>
</template>
<script>

export default {
  name: 'IconAddVideoCamera',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
